import { formatString } from '../../utilities/helpers'

export const formatCardDescription = (card) => {
  const brand = formatString(card?.brand || 'card')
  const last4 = card?.last4 ? `•••• ${card.last4}` : ''
  return [brand, last4].filter(Boolean).join(' ')
}

export const parsePaymentMethodsResponse = (res) => {
  const methods =
    res?.data?.paymentMethods ||
    res?.data?.data ||
    res?.data?.payment_methods ||
    []
  return {
    paymentMethods: Array.isArray(methods) ? methods : [],
    stripeCustomerId: res?.data?.stripeCustomerId || null,
  }
}
